module.exports = __webpack_public_path__ + "static/media/sport-weightlifter.e036eb60.mp4";